<div class="container-group">
  <h2 mat-dialog-title>Edit Trip Schedule</h2>
  <mat-dialog-content class="dialog-content custom-page-scroll">
    <div class="trip-info">
      <span>Block ID: {{ tripData.blockId }}</span>
      <span>Trip ID: {{ tripData.tripId }}</span>
    </div>
    <div class="trip-schedule">
      <div class="schedule-header">
        <div class="center-cell"></div>
        <div class="center-cell">Stop ID</div>
        <div>Stop Name</div>
        <div class="center-cell">Time</div>
        <div class="center-cell">Skip</div>
      </div>
      <div class="schedule-row" *ngFor="let stop of tripData.stops">
        <ng-container *ngIf="stop.stopSequence">
          <div class="center-cell">
            <div class="stop-sequence">{{ stop.stopSequence }}</div>
          </div>
          <div class="center-cell cell">{{ stop.stopId }}</div>
          <div class="stop-cell cell">{{ stop.multilineStop }}</div>
          <div class="center-cell cell">{{ stop.schArrTime }}</div>
          <div class="center-cell cell">
            <mat-checkbox [(ngModel)]="stop.skip"></mat-checkbox>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="onEdit()">
      Edit
    </button>
  </mat-dialog-actions>
</div>
